<template>
  <div :style="styles" class="table-box" ref="tableBox">
    <div class="table-content">
      <div :style="headerBoxStyle" class="header" ref="tableHeader">
        <div :style="headerStyle" ref="header">
          <table-head
            :class-name="headClassName"
            :column-rows="columnRows"
            :columns="cloneColumns"
            :columns-width="columnsWidth"
            @on-head-size="headSize"
          ></table-head>
        </div>
      </div>
      <div :style="tbodyStyle" class="tbody" ref="tableBody">
        <div :style="bodyStyle" class="table-body" ref="body">
          <table-body
            :columns="cloneColumnsSize(cloneColumns, headSizeLise)"
            :columns-width="getColumnsWidth()"
            :data="rebuildData"
            ref="tbody"
          ></table-body>
        </div>
      </div>
    </div>
    <div class="left-fixed" v-if="isLeftFixed">
      <div :style="getFixedHeadStyle(headSizeLise)" class="left-fixed-head">
        <table-head
          :class-name="headClassName"
          :column-rows="leftFixedColumnRows"
          :columns="cloneColumns"
          :columns-width="columnsWidth"
          :fixed="isLeftFixed"
        ></table-head>
      </div>

      <div :style="leftFixedScrollStyle" class="leftFixed" ref="leftFixed">
        <div :style="leftFixedStyle" class="left-fixed-body">
          <table-body
            :columns="getFixedBodyData['head']"
            :columns-width="getColumnsWidth(isLeftFixed)"
            :data="getFixedBodyData['res']"
            :fixed="isLeftFixed"
            ref="tbody"
          ></table-body>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import BScroll from 'better-scroll'
  import tableHead from './table-head'
  import tableBody from './table-body'
  import {
    concatArr,
    convertToRows,
    getAllColumns,
    getFixed,
    getFixedBodyData,
    getFixedList,
    getRandomStr,
    mergeBodySize
  } from './util'
  import {deepCopy, off, on} from '../../utils'
  import renderHeader from './header'

  let rowKey = 1;
  let columnKey = 1;
  export default {
    name: "tap-table",
    data() {
      const colsWithId = this.makeColumnsId(this.header);
      return {
        tableWidth: 0,
        cloneColumns: this.makeColumns(colsWithId),
        columnsWidth: {},
        columnRows: this.makeColumnRows(false, colsWithId),
        rebuildData: [],
        headSizeLise: [],
        leftFixedColumnRows: getFixedList(colsWithId, 'left', this.fixedSize),
        headerHeight: 0,
        headerWidth: 0,
        headerBox: null,
        tbody: null,
        headerElStyles: {},
        tbodyHeight: 0,
        headScroll: {},
        bodyScroll: {
          y: 0,
          x: 0
        },
        isHead: false,
        scrollOn: false,
        leftFixedBScroll: null,
        isLeft: false,
        leftFixedWidth: 0,
        elSize: {}
      }
    },
    props: {
      border: {
        type: Boolean,
        default: false
      },
      headClassName: {
        type: String,
        default: ''
      },
      data: {
        type: Array,
        default() {
          return [];
        }
      },
      header: {
        type: Array,
        default() {
          return []
        }
      },
      width: {
        type: [Number, String]
      },
      height: {
        type: [Number, String],
        default: 600
      },
      rowHeight: [Number, String],
      scrollBottom: {
        type: Boolean,
        default: false
      }
    },
    watch: {
      header: {
        handler() {
          const colsWithId = this.makeColumnsId(this.header)
          this.cloneColumns = this.makeColumns(colsWithId)
          this.rebuildData = this.makeData()
          this.columnRows = this.makeColumnRows(false, colsWithId)
          this.leftFixedColumnRows = getFixedList(colsWithId, 'left', this.fixedSize)

          this.handleResize()
          setTimeout(() => {
            this.initBScroll()
            if (this.isLeftFixed) {
              this.initLeftFixed()
            }
          }, 10)
        },
        deep: true
      },
      data: {
        handler() {
          // const colsWithId = this.makeColumnsId(this.header)
          // this.cloneColumns = this.makeColumns(colsWithId)
          // this.rebuildData = this.makeData()
          // this.columnRows = this.makeColumnRows(false, colsWithId)
          // this.leftFixedColumnRows = getFixedList(colsWithId, 'left', this.fixedSize)
          //
          // this.handleResize()
          // setTimeout(() => {
          //   this.initBScroll()
          //   if (this.isLeftFixed) {
          //     this.initLeftFixed()
          //   }
          // }, 10)
        },
        deep: true
      }
    },
    created() {
      this.rebuildData = this.makeData()
    },
    methods: {
      initBScroll() {
        this.headerBox = new BScroll(this.$refs['tableHeader'], {
          scrollY: true,
          scrollX: true,
          startX: 0,
          startY: 0,
          // stopPropagation: true, // 是否阻止事件冒泡。多用在嵌套 scroll 的场景。
          probeType: 3,
          click: true,
          useTransition: false,
          bounce: {
            top: false,
            bottom: false,
            left: false,
            right: false
          }
        })
        this.headerBox.on('scroll', this.getHeadScroll)
        this.headerBox.on('beforeScrollStart', () => {
          this.isHead = true
        })
        this.tbody = new BScroll(this.$refs['tableBody'], {
          scrollY: true,
          scrollX: true,
          startX: 0,
          startY: 0,
          probeType: 3,
          click: true,
          useTransition: false,
          bounce: {
            top: false,
            bottom: false,
            left: false,
            right: false
          },
          pullDownRefresh: {
            threshold: 50,
            probeType: 3
          },
          pullUpLoad: {
            threshold: 744
          }
        })
        this.tbody.on('scroll', this.getTbodyScroll)
        this.tbody.on('beforeScrollStart', () => {
          this.isLeft = false
          this.isHead = false
        })
        // this.tbody.on('pullingDown', () => {
        //   console.log('a');
        //   this.$nextTick(() => {
        //     this.tbody.refresh() // DOM 结构发生变化后，重新初始化BScroll
        //   })
        //   this.tbody.finishPullDown() // 下拉刷新动作完成后调用此方法告诉BScroll完成一次下拉动作
        // })
        // this.tbody.on('pullingUp', () => {
        //   console.log('b');
        //   this.$nextTick(() => {
        //     this.tbody.refresh()
        //   })
        //   this.tbody.finishPullUp()
        // })
      },
      handleResize() {
        let tableWidth = this.$refs.tableBox.offsetWidth - 1;
        let columnsWidth = {};
        let sumMinWidth = 0;
        let hasWidthColumns = [];
        let noWidthColumns = [];
        let maxWidthColumns = [];
        let noMaxWidthColumns = [];
        this.cloneColumns.forEach((col) => {
          if (col.width) {
            hasWidthColumns.push(col);
          } else {
            noWidthColumns.push(col);
            if (col.minWidth) {
              sumMinWidth += col.minWidth;
            }
            if (col.maxWidth) {
              maxWidthColumns.push(col);
            } else {
              noMaxWidthColumns.push(col);
            }
          }
          col._width = null;
        });
        let unUsableWidth = hasWidthColumns.map(cell => cell.width).reduce((a, b) => a + b, 0);
        let usableWidth = tableWidth - unUsableWidth - sumMinWidth;
        let usableLength = noWidthColumns.length;
        let columnWidth = 0;
        if (usableWidth > 0 && usableLength > 0) {
          columnWidth = parseInt(usableWidth / usableLength);
        }
        for (let i = 0; i < this.cloneColumns.length; i++) {
          const column = this.cloneColumns[i];
          let width = columnWidth + (column.minWidth ? column.minWidth : 0);
          if (column.width) {
            width = column.width;
          } else {
            if (column._width) {
              width = column._width;
            } else {
              if (column.minWidth > width) {
                width = column.minWidth;
              } else if (column.maxWidth < width) {
                width = column.maxWidth;
              }
              if (usableWidth > 0) {
                usableWidth -= width - (column.minWidth ? column.minWidth : 0);
                usableLength--;
                if (usableLength > 0) {
                  columnWidth = parseInt(usableWidth / usableLength);
                } else {
                  columnWidth = 0;
                }
              } else {
                columnWidth = 0;
              }
            }
          }
          column._width = width;
          columnsWidth[column._index] = {
            width: width
          };
        }
        if (usableWidth > 0) {
          usableLength = noMaxWidthColumns.length;
          columnWidth = parseInt(usableWidth / usableLength);
          for (let i = 0; i < noMaxWidthColumns.length; i++) {
            const column = noMaxWidthColumns[i];
            let width = column._width + columnWidth;
            if (usableLength > 1) {
              usableLength--;
              usableWidth -= columnWidth;
              columnWidth = parseInt(usableWidth / usableLength);
            } else {
              columnWidth = 0;
            }
            column._width = width;
            columnsWidth[column._index] = {
              width: width
            };
          }
        }
        this.tableWidth = this.cloneColumns.map(cell => cell._width).reduce((a, b) => a + b, 0)
        this.columnsWidth = columnsWidth;
        this.fixedHeader()
      },
      makeColumns(cols) {
        let columns = deepCopy(getAllColumns(cols))
        let left = [];
        let right = [];
        let center = [];

        columns.forEach((column, index) => {
          column._index = index;
          column._columnKey = columnKey++;
          column._width = column.width ? column.width : '';
          column._lineHeight = this.rowHeight || '32'
          if (column.fixed && column.fixed === 'left') {
            left.push(column);
          } else if (column.fixed && column.fixed === 'right') {
            right.push(column);
          } else {
            center.push(column);
          }
        });
        return left.concat(center).concat(right);
      }, // 在 data 时，this.allColumns 暂时为 undefined
      makeColumnRows(fixedType, cols) {
        let data = convertToRows(cols, fixedType)
        if (fixedType) {
          let arr = []
          data.forEach(item => {
            arr = concatArr(arr, item)
          })
          return getFixed(arr, fixedType)
        } else {
          return data
        }
        // return convertToRows(cols, fixedType)
      },
      makeColumnsId(columns) {
        return columns.map(item => {
          if ('children' in item) this.makeColumnsId(item.children)
          item._id = getRandomStr(6)
          return item
        })
      }, // 修改列，设置一个隐藏的 id，便于后面的多级表头寻找对应的列，否则找不到
      makeData() {
        let data = deepCopy(this.data);
        data.forEach((row, index) => {
          row._index = index;
          row._rowKey = rowKey++;
        });
        return data;
      }, // 处理数据
      fixedHeader() {
        if (this.height) {
          this.$nextTick(() => {
            this.$nextTick(() => this.fixedBody());
          });
        } else {
          this.$nextTick(() => this.fixedBody());
        }
      },
      fixedBody() {
        if (this.$refs.header) {
          this.headerWidth = this.$refs.header.children[0].offsetWidth;
          this.headerHeight = this.$refs.header.children[0].offsetHeight;
        }
        if (this.$refs.tbody) {
          let bodyContentEl = this.$refs.tbody.$el;
          // let bodyEl = bodyContentEl.parentElement;
          let bodyContentHeight = bodyContentEl.offsetHeight;
          // let bodyHeight = bodyEl.offsetHeight;
          this.tbodyHeight = bodyContentHeight
        }
      },
      headSize(size) {
        this.headSizeLise = size
      },
      getHeadScroll(e) {
        if (this.isHead) {
          this.tbody.scrollTo(e.x, this.bodyScroll.y)
        }
      },
      getTbodyScroll(e) {
        this.bodyScroll = e
        if (!this.isHead) {
          this.headerBox.scrollTo(e.x, 0)
          if (!this.isLeft && this.leftFixedBScroll) this.leftFixedBScroll.scrollTo(0, e.y)
        }
      },
      initLeftFixed() {
        this.leftFixedBScroll = new BScroll(this.$refs['leftFixed'], {
          scrollY: true,
          // scrollX: true,
          startX: 0,
          startY: 0,
          probeType: 3,
          click: true,
          useTransition: false,
          bounce: {
            top: false,
            bottom: false,
            left: false,
            right: false
          }
        })
        this.leftFixedBScroll.on('scroll', this.getLeftFixedScroll)
        this.leftFixedBScroll.on('beforeScrollStart', () => {
          this.isLeft = true
        })
      },
      getLeftFixedScroll(e) {
        if (this.isLeft) {
          this.tbody.scrollTo(this.bodyScroll.x, e.y)
        }
      }
    },
    components: {
      tableHead,
      tableBody,
      renderHeader
    },
    computed: {
      getFixedHeadStyle() {
        return size => {
          if (size) {
            let w = []
            let h = []
            let wMun = 0
            size.forEach((item) => {
              if (item.fixed) {
                w.push(item.width)
                h.push(item.height)
                wMun += item.width
              }
            })
            this.leftFixedWidth = wMun
            return {
              width: wMun + 'px',
              height: Math.max.apply(null, h) + 'px'
            }
          } else {
            return {}
          }
        }
      },
      getFixedBodyData() {
        let data = this.makeData()
        let head = this.cloneColumns
        return getFixedBodyData(data, head)
      },
      isLeftFixed() {
        return this.header.some(col => col.fixed && col.fixed === 'left')
      },
      getColumnsWidth() {
        return (isFixed) => {
          let size = this.headSizeLise
          let off = size.map(item => {
            return {width: item.width}
          })
          let on = size.filter(item => item.fixed).map(item => {
            return {width: item.width}
          })
          return isFixed ? on : off
        }
      },
      cloneColumnsSize() {
        return (list, size) => {
          return mergeBodySize(list, size)
        }
      },
      styles() {
        let style = {}
        if (this.height) {
          style.height = `${parseInt(this.height)}px`
        } else {
          style.height = `${this.elSize.height || 0}px`
        }
        if (this.width) {
          style.width = `${parseInt(this.width)}px`
        } else {
          style.width = `${this.elSize.width || 0}px`
        }
        return style
      },
      headerBoxStyle() {
        let style = {}
        if (this.width) {
          style.width = `${parseInt(this.width)}px`
        } else {
          style.width = `${this.elSize.width}px`
        }
        return style
      },
      headerStyle() {
        let style = {}
        if (this.headerWidth) {
          style.width = `${this.headerWidth}px`
        }
        if (this.headerHeight) {
          style.height = `${this.headerHeight}px`
        }
        return style
      },
      tbodyStyle() {
        let style = {}
        if (this.width) {
          style.width = `${parseInt(this.width)}px`
        } else {
          style.width = `${this.elSize.width}px`
        }
        style.height = `${parseInt(this.height || this.elSize.height) - this.headerHeight}px`
        return style
      },
      bodyStyle() {
        let style = {}
        if (this.headerWidth) {
          style.width = `${this.headerWidth}px`
        }
        if (this.tbodyHeight) {
          style.height = `${this.tbodyHeight}px`
        }
        return style
      },
      leftFixedScrollStyle() {
        let style = {}
        if (this.leftFixedWidth) {
          style.width = `${this.leftFixedWidth}px`
        }
        style.height = `${parseInt(this.height || this.elSize.height) - this.headerHeight}px`
        return style
      },
      leftFixedStyle() {
        let style = {}
        if (this.leftFixedWidth) {
          style.width = `${this.leftFixedWidth}px`
        }
        if (this.tbodyHeight) {
          style.height = `${this.tbodyHeight}px`
        }
        return style
      }
    },
    mounted() {
      this.handleResize()
      setTimeout(() => {
        this.$nextTick(() => {
          this.elSize = {width: this.$refs.tableBox.offsetWidth, height: this.$refs.tableBox.offsetHeight};
          this.initBScroll()
          if (this.isLeftFixed) {
            this.initLeftFixed()
          }
        })
      }, 10)
      on(window, 'resize', this.handleResize);
    },
    beforeDestroy() {
      off(window, 'resize', this.handleResize);
    }
  }
</script>

<style lang="scss" scoped>
  @import "style";

  .table-box {
    overflow: hidden;
    position: relative;

    .header {
      position: relative;
      z-index: 2;
      overflow: hidden;
    }

    .tbody {
      overflow: hidden;
      /*<!--margin-top: -1PX;-->*/
    }

    .left-fixed {
      position: absolute;
      top: 0;
      left: 0;

      .left-fixed-head {
        position: relative;
        z-index: 3;
        /*line-height: ;*/
      }

      .leftFixed {
        /*<!--margin-top: -1PX;-->*/
      }
    }
  }
</style>
